import * as apiProxy from 'BASE/common/util/util.apiProxy';
import { storage } from 'BASE/common/util/util.storage';

export const redirect = (function () {
    let EnableRedirectChatRoom = false;
    let IsFirstRedirect = false;

    function enableRedirectChatRoom(enable){
        EnableRedirectChatRoom = enable;
    }

    function isFirstRedirect(enable){
        IsFirstRedirect = enable;
    }

    function RecordLastURL(to, donotRedirectPage){
        // Cordova下，進入頁面後，紀錄router path位置
        if(ENVIRONMENT.CORDOVA){
            let url = to.fullPath;
            if(donotRedirectPage.indexOf(url) >= 0){
                return;
            }
    
            let expiresTime = new Date().getTime() + (60 * 60 * 1000); //有效一小時
            storage.local.set(storage.keys.LAST_VIEWED_PAGE, url, expiresTime);
        }
    }

    function RedirectLastURL(next){
        // Cordova下，若APP被手機OS關閉，重啟APP時，導回上次瀏覽頁面
        if(ENVIRONMENT.CORDOVA){
            let lastViewedPage = storage.local.get(storage.keys.LAST_VIEWED_PAGE);
            var token = storage.local.get(storage.keys.ACCESS_TOKEN);
            if(IsFirstRedirect && lastViewedPage && token){
                // 若最後頁面是聊天室，確認是否在對話視窗中裡，是的話回到該對話視窗
                let lastChatRoomId = storage.local.get(storage.keys.LAST_CHATROOMID);
                if(EnableRedirectChatRoom && lastViewedPage.indexOf('Chat') && lastChatRoomId){
                    lastViewedPage = '/Chat?chatRoomId=' + lastChatRoomId;
                }
                IsFirstRedirect = false;
                next(lastViewedPage);
            }
            else if(IsFirstRedirect && lastViewedPage && !token){
                // 如果token失效了就清掉紀錄
                IsFirstRedirect = false;
                storage.local.remove(storage.keys.LAST_VIEWED_PAGE);
                storage.local.remove(storage.keys.LAST_CHATROOMID);
            }
        }
    }

    function RedirectPage(path = "/"){
        if(ENVIRONMENT.CORDOVA){
            if (storage.local.get(storage.keys.ACCESS_TOKEN)){
                window.location.href = apiProxy.urlRedirect(path);
            }
        }
    }

    return {
        recordLastURL:RecordLastURL,
        redirectLastURL:RedirectLastURL,
        enableRedirectChatRoom:enableRedirectChatRoom,
        isFirstRedirect:isFirstRedirect,
        redirectPage:RedirectPage,
    };
})();